import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import RootState from '../rootState';

// state
export interface ReduxSystemState {
  loading: {
    isActive: boolean;
    preloading: boolean;
  };
}

// state の初期値
const systemInitialState: ReduxSystemState = {
  loading: {
    isActive: false,
    preloading: false,
  },
};

// actions と reducers の定義
const slice = createSlice({
  name: 'system',
  initialState: systemInitialState,
  reducers: {
    loading: (state, action: PayloadAction<ReduxSystemState['loading']['isActive']>) => {
      state.loading.isActive = action.payload;
    },
    preloading: (state, action: PayloadAction<ReduxSystemState['loading']['preloading']>) => {
      state.loading.preloading = action.payload;
    },
  },
});

export default slice;
export const systemSelector = (state: RootState): ReduxSystemState => state.system;
export const systemActions = slice.actions;
